import moment from 'moment';

const timeFormAPI = {
  changeData: (dateString) => {
    if (dateString !== null && dateString !== '' && dateString !== '-') {
      // const dateObj = new Date(dateString);
      const formattedDate = moment(dateString).format('YYYY-MM-DD');
      // const formattedTime = moment(dateObj).format('A hh:mm');
      const formattedTime = moment(dateString).format('HH:mm');
      // const amPm = moment(dateString).format('A') === 'AM' ? '오전' : '오후';

      return `${formattedDate} ${formattedTime}`;
    }
    return '-';
  },

  changeDataDate: (dateString) => {
    if (!dateString) {
      return '-';
    }
    if (dateString === '') {
      return '-';
    }
    if (dateString === '-') {
      return '-';
    }
    const formattedDate = moment(dateString).format('YYYY-MM-DD');
    // const formattedTime = moment(dateString).format('HH:mm:ss.SSS');

    return `${formattedDate}`;
  },

  changeDataLog: (dateString) => {
    if (!dateString) {
      return '-';
    }
    if (dateString === '') {
      return '-';
    }
    if (dateString === '-') {
      return '-';
    }
    const formattedDate = moment(dateString).format('YYYY-MM-DD');
    const formattedTime = moment(dateString).format('HH:mm:ss.SSS');

    return `${formattedDate}T${formattedTime}`;
  },

  changeDataLogK: (dateString) => {
    if (dateString !== null && dateString !== '' && dateString !== '-') {
      // const dateObj = new Date(dateString);
      const formattedDate = moment(dateString)
        .add(9, 'hours')
        .format('YYYY-MM-DD');
      // const formattedTime = moment(dateObj).format('A hh:mm');
      const formattedTime = moment(dateString)
        .add(9, 'hours')
        .format('HH:mm:ss.SSS');
      // const amPm = moment(dateString).format('A') === 'AM' ? '오전' : '오후';

      return `${formattedDate}T${formattedTime}`;
    }
    return '-';
  },

  // eslint-disable-next-line consistent-return
  changeDateTime: (dateTimeString) => {
    // console.log('dateTimeString: ', dateTimeString);
    if (dateTimeString !== null) {
      const formattedDate = moment(dateTimeString).format('YYYY-MM-DD');
      const formattedTime = moment(dateTimeString).format('HH:mm');
      // const dateTime = new Date(dateTimeString);
      //
      // // 원하는 형식으로 날짜 변환
      // const formattedDate = `${dateTime.getFullYear()}.${(dateTime.getMonth() + 1).toString().padStart(2, '0')}.${dateTime.getDate().toString().padStart(2, '0')}`;
      // const formattedTime = `${dateTime.getHours().toString().padStart(2, '0')}:${dateTime.getMinutes().toString().padStart(2, '0')}:${dateTime.getSeconds().toString().padStart(2, '0')}`;

      return `${formattedDate} ${formattedTime}`;
    }
    return '-';
  },

  changeTime: (timeString) => {
    if (timeString !== null && timeString !== '' && timeString !== '-') {
      const formattedTime = moment(timeString, 'HH:mm');
      return formattedTime.format('HH:mm');
    }
    return '-';
  },

  // eslint-disable-next-line consistent-return
  formatUTC: (dateTimeString) => {
    if (dateTimeString !== null) {
      const date = new Date(dateTimeString);
      const year = date.getUTCFullYear();
      const month = this.formatNumber(date.getUTCMonth() + 1);
      const day = this.formatNumber(date.getUTCDate());
      let hours = date.getUTCHours();
      const minutes = this.formatNumber(date.getUTCMinutes());
      const seconds = this.formatNumber(date.getUTCSeconds());
      let amPm = '오전';

      if (hours >= 12) {
        amPm = '오후';
        hours %= 12;
      }

      hours = this.formatNumber(hours);

      return `${year}-${month}-${day} ${amPm} ${hours}:${minutes}:${seconds}`;
    }
    if (
      dateTimeString === null ||
      dateTimeString === '' ||
      dateTimeString === '-'
    ) {
      return '-';
    }
  },

  durationTime: (start, end) => {
    if (!end) return '-';

    const startTime = moment(start);
    const endTime = moment(end);
    const duration = moment.duration(endTime.diff(startTime));

    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    let result = '';
    if (hours > 0) result += `${hours}시간`;
    if (minutes > 0) result += `${minutes}분`;
    if (seconds > 0) result += `${seconds}초`;

    return result || '1초 미만';
  }
};

export default timeFormAPI;
